import React from 'react'
import Header from '../components/Header'
import Navbar from '../components/Navbar'
import HeroSlider from '../components/HeroSlider'
import Footer from '../components/Footer'
import TopInfoBar from '../components/TopInfoBar'
import LocatorFinder from './LocatorFinder'
import EMICalculator from '../components/EmiCalculator'
import LoanSection from '../components/LoanSection'
import InterestRateSection from '../components/InterestRateSection'
import DeafFundNotice from '../components/DeafFundNotice'


export default function Home() {
    return (
        <>
            <TopInfoBar />
            <Header />
            <Navbar />

            <HeroSlider />
            
            <div className="container mx-auto px-4 mt-12 mb-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
                <div className="lg:col-span-6 flex flex-col">
                    <EMICalculator compact={true} />
                </div>
                <div className="lg:col-span-6 flex flex-col">
                    <DeafFundNotice compact={true} />
                </div>
            </div>

            <div className="space-y-10 mt-10">
                <InterestRateSection />
                <LoanSection />
                <LocatorFinder />
            </div>
            <Footer />
        </>
    )
}
